'use client';

import i18next from 'i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import {
  initReactI18next,
  useTranslation as original_useTranslation,
} from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getOptions } from './settings';
import { useCurrentLanguageCode } from '@/shared/utils/client';

i18next
  .use(intervalPlural)
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`)
    )
  )
  .init(getOptions());

export function useTranslation(ns: string[] | string) {
  const language = useCurrentLanguageCode();
  if (i18next.resolvedLanguage !== language) i18next.changeLanguage(language);
  return original_useTranslation(ns);
}
